import { jsx as _jsx } from "react/jsx-runtime";
const ApiErrorMessage = (props) => {
    const { apiError } = props;
    return (_jsx("div", Object.assign({ style: {
            color: 'var(--pink-base)',
            textAlign: 'center',
            fontSize: '0.75rem',
        } }, { children: apiError['message']
            ? apiError['message']
            : 'There was an error. Please try again later.' }), void 0));
};
export default ApiErrorMessage;
